module.exports = __webpack_public_path__ + "img/service-details.51bd6a09.jpg";